import GenericDB from './generic-db';

export default class TeamMembershipsDB extends GenericDB {
  constructor() {
    super('teamMemberships');
  }
}
